import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import PlanningPage from './pages/PlanningPage';
import LiveDataListPage from './pages/LiveDataListPage';
import LiveComparisonPage from './pages/LiveComparisonPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ReviewPage from './pages/ReviewPage';
import MonitorPage from './pages/MonitorPage';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="/planning" element={<PlanningPage />} />
        <Route path="/live-data" element={<LiveDataListPage />} />
        <Route path="/comparison" element={<LiveComparisonPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/review/:id" element={<ReviewPage />} />
        <Route path="/monitor" element={<MonitorPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
